import React, { createContext, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { directus } from '../api';
import { AuthContextType } from '../types/AuthContextType';
import { Storage } from '../components';

const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps {
  children: React.ReactNode;
}

const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const storage = new Storage('directus-data');
  const [token, setToken] = useState<JSON>(storage.get()|| {});
  const navigate = useNavigate();

  const loginAction = async (data: { email: string; password: string }) => {
    try {
      const response = await directus.login(data.email, data.password, {mode: 'json'});
      if (response.access_token && response.refresh_token && response.expires_at) {
        storage.set({
          access_token: response.access_token,
          refresh_token: response.refresh_token,
          expires_at: response.expires_at
        });
        setToken(storage.get());
        navigate('/');
        return true;
      }
    } catch (err) {
      return false;
    }
    return false;
  };

  const logOut = () => {
    // logout via directus configuration
    directus.logout();

    // clean up token in localStorage
    storage.set({})
    navigate('/login');
  };

  return (
    <AuthContext.Provider value={{ token, loginAction, logOut }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  
  return context;
};

export default AuthProvider;